



















import { Component, Vue } from "vue-property-decorator";

@Component
class ModalAuthRequire extends Vue {
  get dialog() {
    const currentPageNeedFoxoneMigrate = this.$store.state.app
      .currentPageNeedFoxoneMigrate;
    const needFoxoneMigrate = this.$store.state.app.needFoxoneMigrate;
    const notShowMigrateThisSession = this.$store.state.app
      .notShowMigrateThisSession;
    return (
      !notShowMigrateThisSession &&
      currentPageNeedFoxoneMigrate &&
      needFoxoneMigrate
    );
  }

  handleOK() {
    this.$store.commit("app/SET_NOT_SHOW_MIGRATE_THIS_SESSION", true);
  }
}
export default ModalAuthRequire;
